import { Link } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { Card, CardContent } from '@/components/ui/card';
import { formatCents } from '@/lib/format/currency';
import { MY_CPM_WALLET } from '@/queries/queries';

// The one balance that can actually be withdrawn now, next to lifetime totals
// on /affiliates and /course-royalties.
export const WithdrawableBalanceCard = () => {
  const { t } = useTranslation();
  const { data } = useQuery<{ myCpmWallet: { available_cents: number } }>(MY_CPM_WALLET);
  const available = data?.myCpmWallet?.available_cents;
  return (
    <Card>
      <CardContent className="pt-6">
        <div className="text-sm text-muted-foreground">{t('walletStatement.withdrawable.label')}</div>
        <div className="text-xl font-bold tabular-nums">
          {available === undefined ? '—' : formatCents(available, 'BRL')}
        </div>
        <Link to="/earn/wallet#extrato" className="mt-1 inline-block text-xs text-primary hover:underline">
          {t('walletStatement.withdrawable.link')}
        </Link>
      </CardContent>
    </Card>
  );
};

export default WithdrawableBalanceCard;
